import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.element.addEventListener('turbo:submit-end', this.handleSubmitEnd.bind(this))

    requestAnimationFrame(() => {
      const hasLocalTrigger = this.element.querySelector('[data-action*="modal#open"]')
      const dialogId = this.modalTarget?.id
      let hasExternalTrigger = false

      if (dialogId) {
        hasExternalTrigger = !!document.querySelector(`[data-action*="modal-trigger#open"]`)
      }

      if (!hasLocalTrigger && !hasExternalTrigger) {
        this.open()
      }
    })
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-end', this.handleSubmitEnd.bind(this))
    document.body.classList.remove("overflow-hidden")
  }

  open(event) {
    if (event) event.preventDefault()
    this.modalTarget.showModal()
    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.close()
  }

  onClose() {
    document.body.classList.remove("overflow-hidden")
  }

  trackMouseDown(event) {
    this.mouseDownTarget = event.target
  }

  clickOutside(event) {
    if (this.mouseDownTarget !== this.modalTarget) return
    if (event.target !== this.modalTarget) return

    const rect = this.modalTarget.getBoundingClientRect()

    const isOutside = (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    )

    if (isOutside) {
      this.close()
    }
  }

  handleSubmitEnd(event) {
    if (event.detail.success) {
      this.close()
    }
  }
}
